import React, { useEffect } from 'react'
import Sidebar from '../../components/Sidebar'
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { oberserventUserValidation } from '../../schemas/categoryValidation';
import backImg from "../../assets/images/back.png"
import useUrlState from '../../hooks/useUrlState';
import { useNavigate } from 'react-router-dom';

const CreateOberserventUser = () =>
{
    const initialValues = {
        name: '',
        email: '',
        phoneNo: null,
        password: "",
        confirmPassword: "",
    };
    const onSubmit = (values) =>
    {
        console.log("value", values)
    };
    const navigate = useNavigate()
    const data = useUrlState()


    // handle back
    const handleBack = () =>
    {
        window.history.back()
    }


    useEffect(() =>
    {
        if (!data?.createSuccess)
        {
            navigate('/dashboard')
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div>
            <div className="mainLayout">
                <div className="mainLayout_parent">
                    <Sidebar index={"5b"} />
                    <div className="dashboard">
                        <div className="dashboard_topBar">
                            <div>
                                <p className="dashboard_title">
                                    <img onClick={handleBack} className='dashboard_backImg shadow' src={backImg} alt="backImg" /> Create Observant User</p>
                            </div>
                            <div>
                            </div>
                        </div>
                        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={oberserventUserValidation}>
                            <Form>
                                <div className="createSale_left">
                                    <div className="createSale_form">
                                        <div>
                                            <p htmlFor="firstName">Name</p>
                                            <Field placeholder="Name" type="text" id="name" name="name" />
                                            <ErrorMessage className="createSale_err" name="name" component="div" />
                                        </div>
                                        <div>
                                            <p htmlFor="email">Email</p>
                                            <Field placeholder="Email" type="text" id="email" name="email" />
                                            <ErrorMessage className="createSale_err" name="email" component="div" />
                                        </div>
                                    </div>

                                    <div className="createSale_form">
                                        <div className="createSale_form">
                                            <div>
                                                <p htmlFor="refId">Password</p>
                                                <Field placeholder="Password" type="password" id="password" name="password" />
                                                <ErrorMessage className="createSale_err" name="password" component="div" />
                                            </div>
                                            <div>
                                                <p htmlFor="refId">Confirm Password</p>
                                                <Field placeholder="Confirm Password" type="password" id="confirmPassword" name="confirmPassword" />
                                                <ErrorMessage className="createSale_err" name="confirmPassword" component="div" />
                                            </div>
                                        </div>
                                        <div className="createSale_form">
                                            <div>
                                                <p htmlFor="refId">Phone Number</p>
                                                <Field placeholder="Phone Number" type="number" id="phoneNo" name="phoneNo" />
                                                <ErrorMessage className="createSale_err" name="phoneNo" component="div" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="createSale_submit">
                                    <button type='submit'>Create</button>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CreateOberserventUser